/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SimpleTimeWorkedCalculationRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {CheckOvertimePrerequisitesResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const checkOvertimePrerequisites = (request: SimpleTimeWorkedCalculationRequest, options?: CashRequestOptions) => post<SimpleTimeWorkedCalculationRequest, CheckOvertimePrerequisitesResponse>("/proxy/services/squareup.timecards.TimeCalculationService/CheckOvertimePrerequisites", request, {...options, rejectOnError: true })